import angular from 'angular'
import { StatusViewComponent } from '../../scripts/components/status/StatusView'
import { TrackingProvider } from './tracking/tracking.service'

// Sale
import { SalePromoCodeComponent } from './sale/sale-promo-code/sale-promo-code.component'
import { SaleTaxBreakdownComponent } from './sale/sale-tax-breakdown/sale-tax-breakdown.component'
import { SalePromotionComponent } from './sale/sale-promotion/sale-promotion.component'
import { SalePaymentComponent } from './sale/sale-payment/sale-payment.component'
import { SaleInventoryData as SaleInventoryDataService } from './sale/sale-inventory-data/sale-inventory-data.service'
import { MarkUnfulfilledModalService } from './react/modals/mark-as-unfulfilled-modal/mark-unfulfilled-modal.service'
import { QuoteCustomerModalService } from './react/modals/quote-customer-modal/quote-customer-modal-service'
import { ServiceModalService } from './react/modals/service-modal/service-modal.service'
import { AccountBalanceSetupModalService } from './sale/account-balance-setup-modal/account-balance-setup-modal.service'
import { ErroredSalesModalController } from './sale/errored-sales-modal/errored-sales-modal.controller'
import { RetrieveSalePopoverController } from './sale/retrieve-sale/retrieve-sale-popover/retrieve-sale-popover.controller'
import { SalePromoCodePopoverController } from './sale/sale-promo-code/sale-promo-code-popover.controller'
import { OutletsDifferModalController } from './sale/outlets-differ-modal/outlets-differ-modal.controller'
import { MarkUnfulfilledModalController } from './react/modals/mark-as-unfulfilled-modal/mark-unfulfilled-modal.controller'
import { QuoteCustomerModalController } from './react/modals/quote-customer-modal/quote-customer-modal.controller'
import { ServiceModalController } from './react/modals/service-modal/service-modal.controller'
import { ServiceSaleRefundModalController } from './react/modals/service-sale-refund-modal/service-sale-refund-modal.controller'
import { AccountBalanceSetupModalController } from './sale/account-balance-setup-modal/account-balance-setup-modal.controller'
import { SaleNoteReduxComponent } from './sale/sale-note-redux/sale-note-redux.component'
import { AttachCustomerTooltip } from './sale/attach-customer-tooltip/attach-customer-tooltip.directive'
import { UnknownLineItemComponent } from './sale/unknown-line-item/UnknownLineItem'

// React Components
// -- Sale
import { LineItemDiscountPercentComponent } from './sale/sale-line-item/LineItemDiscountPercent'
import { LineItemDisplayComponent } from './sale/sale-line-item/LineItemDisplay'
import { LineItemMarkupPercentComponent } from './sale/sale-line-item/LineItemMarkupPercent'
import { LineItemNoteComponent } from './sale/sale-line-item/LineItemNote'
import { LineItemPriceComponent } from './sale/sale-line-item/LineItemPrice'
import { LineItemQuantityComponent } from './sale/sale-line-item/LineItemQuantity'
import { SaleSummaryLineItemsComponent } from './sale/sale-line-item/SaleSummaryLineItems'
import { MarkAsUnfulfilledModalComponent } from './react/modals/mark-as-unfulfilled-modal/MarkAsUnfulfilledModal'
import { QuoteCustomerModalComponent } from './react/modals/quote-customer-modal/QuoteCustomerModal'
import { ServiceModalComponent } from './react/modals/service-modal/ServiceModal'
import { ServiceSaleRefundModalComponent } from './react/modals/service-sale-refund-modal/ServiceSaleRefundModal'
import { AccountBalanceSetupModalComponent } from './sale/account-balance-setup-modal/AccountBalanceSetupModal'
import { SalesPersonSelectComponent } from './sale/sales-person-popover/SalesPersonSelect'
import { SalesPersonInfoComponent } from './sale/sales-person-popover/SalesPersonInfo'
import { ReactSaleErrorBannerComponent } from './sale/sale-error/SaleErrorBanner'
import { ReactSaleFulfilmentBannerComponent } from './sale/sale-fulfilment/SaleFulfilmentBanner'
import { ReactSalePromotionBannerComponent } from './sale/sale-promotion/SalePromotionBanner'
import { ReactSaleReturnBannerComponent } from './sale/sale-return/SaleReturnBanner'
import { ReactSaleServiceBannerComponent } from './sale/sale-service/SaleServiceBanner'
// -- Shared
import { wrToastNotifications } from './react/helios/ToastNotifications/WrToastNotifications'
import { wrDisplayTaxRate } from './util/TaxRate'
// -- Promotion
import { vbPromotionModal } from './promotions/promotion-modal/PromotionModalWrapper'

// Sale Confirmation
import { ReceiptSelectionPopoverController } from './receipts/receipt-selection-popover/receipt-selection-popover.controller'
import { ReceiptSelectionEmailToggleComponent } from './receipts/receipt-selection-email-toggle/receipt-selection-email-toggle.component'
import { ReceiptPrintSelectedComponent } from './receipts/receipt-print-selected/receipt-print-selected.component'
import { QuotePrintComponent } from './receipts/quote-print/quote-print.component'

// Shared
import { HasCCErrorMessageComponent } from './shared/has-cc-error-message/HasCCErrorMessage'
import { PreloadReceiptImagesComponent } from './shared/preload-receipt-images/preload-receipt-images.component'
import { NoPermissionsPageComponent } from './react/react-utilities/NoPermissionsPage'
import './react'

// Register
import { OpenRegisterPanelComponent } from './register/open-register-panel/open-register-panel.component'
import { OpenRegisterContinueSaleController } from './register/open-register-continue-sale/open-register-continue-sale.controller'
import { RegisterClosureInfoComponent } from './register/register-closure-info/register-closure-info.component'
import { RegisterClosureSummaryNotesComponent } from './register/register-closure-summary-notes/RegisterClosureSummaryNotes'
import { RegisterActionsPopoverController } from './register/register-actions/register-actions-popover.controller'
import './register/registers-resource/registers-resource'

// Register Open Reminder
import './register/register-open-reminder/register-open-reminder'

// Select Register Modal
import { SelectRegisterModalComponent } from './select-register/selectRegisterModal'

// Cash Management
import { SetCashFloatController } from './cash-management/set-cash-float/set-cash-float.controller'
import { SetCashFloatNotesComponent } from './cash-management/set-cash-float/SetCashFloatNotes'
import { SetCashFloatFormComponent } from './cash-management/set-cash-float/set-cash-float-form.component'
import { CashManagementViewComponent } from './cash-management/CashManagementView'
import { ReactSaleViewComponent } from './sale/sale-view'
import { AddProductToSaleModalsComponent } from './AddProductToSale/AddProductToSaleModals'

// Gift Cards
import './gift-cards/gift-cards-resource/gift-cards-resource'

// Route Management
import './route-management/route-management'

// Payments
import './payments/payments'

// Customer
import './customer/customer'

// Product
import './product/product'

// Restricted Access
import './restricted-access/restricted-access'
import { wrNoProductsModal } from './restricted-access/NoProductsModal'

// Promotion
import './promotions/promotions-resource/promotions-resource'
import { PromotionModalService } from './promotions/promotion-modal/promotion-modal.service'
import { PromotionModalController } from './promotions/promotion-modal/promotion-modal.controller'

// Sales
import './sale/sales-resource/sales-resource'

// Search
import './search/search-resource/search-resource'

// User Switching
import './users/user-switching/user-switching'

// Service Worker Manager
import './service-worker/service-worker-manager/service-worker-manager'

// Barcode service
import './sale/barcode/barcode'

// Sale Versioning Manager
import './sale/sale-versioning-manager/sale-versioning-manager'

// Hot Keys
import './hotkeys/hotkeys'

// Workflows
import './workflows/workflows'

// Sale Tracker
import './sale/sale-tracker/sale-tracker'

// Cash Movement Receipt
import './receipts/cash-movement-receipt/CashMovementReceipt'

// Store Credit Issue Receipt
import './receipts/store-credit-issue-receipt/StoreCreditIssueReceipt'

import { wrColouredNumber } from './util/ColouredNumber'
import { ToggleLastLineItem } from './sale/toggle-last-line-item/toggle-last-line-item'
import { ServiceSaleRefundModalService } from './react/modals/service-sale-refund-modal/service-sale-refund-modal.service'
import { OfflinePage } from './offline/Offline'
import { LineItemTabsComponent } from './sale/sale-line-item/LineItemTabs'
import { LineItemDisplayFulfilmentComponent } from './sale/sale-line-item/fulfilment/LineItemDisplayFulfilment'
import { ReceiptSelectionEmailToggleController } from './receipts/receipt-selection-email-toggle/receipt-selection-email-toggle.controller'
import { ReactSaleActionsComponent } from './sale/sale-actions/SaleActions'
import { ReactSummaryPanel } from './sale/summary-panel/SummaryPanel'
import { ReactPaymentPanel } from './sale/payment-panel/PaymentPanel'
import { WorkSpaceComponent } from './workspace/Workspace'
import { ReactConfirmationPanel } from './sale/confirmation-panel/ConfirmationPanel'
angular
  .module('webregister.components')

  .provider('tracking', TrackingProvider)

  .service('saleInventoryData', SaleInventoryDataService)
  .service('markUnfulfilledModalService', MarkUnfulfilledModalService)
  .service('quoteCustomerModalService', QuoteCustomerModalService)
  .service('serviceModalService', ServiceModalService)
  .service('serviceSaleRefundModalService', ServiceSaleRefundModalService)
  .service('accountBalanceSetupModalService', AccountBalanceSetupModalService)
  .service('promotionModalService', PromotionModalService)

  .directive('toggleLastLineItem', ToggleLastLineItem)

  .component('salePromoCode', SalePromoCodeComponent)
  .component('salePromotion', SalePromotionComponent)
  .component('salePayment', SalePaymentComponent)
  .component('saleTaxBreakdown', SaleTaxBreakdownComponent)
  .component('hasCcErrorMessage', HasCCErrorMessageComponent)
  .component('preloadReceiptImages', PreloadReceiptImagesComponent)
  .component('openRegisterPanel', OpenRegisterPanelComponent)
  .component('registerClosureInfo', RegisterClosureInfoComponent)
  .component('setCashFloatNotes', SetCashFloatNotesComponent)
  .component(
    'registerClosureSummaryNotes',
    RegisterClosureSummaryNotesComponent
  )
  .component('setCashFloatForm', SetCashFloatFormComponent)
  .component('cashManagementView', CashManagementViewComponent)
  .component('wrColouredNumber', wrColouredNumber)
  .component('wrNoProductsModal', wrNoProductsModal)
  .component('wrDisplayTaxRate', wrDisplayTaxRate)
  .component('saleNoteRedux', SaleNoteReduxComponent)
  .component('lineItemDiscountPercent', LineItemDiscountPercentComponent)
  .component('lineItemDisplay', LineItemDisplayComponent)
  .component('lineItemDisplayFulfilment', LineItemDisplayFulfilmentComponent)
  .component('lineItemTabs', LineItemTabsComponent)
  .component('lineItemMarkupPercent', LineItemMarkupPercentComponent)
  .component('lineItemNote', LineItemNoteComponent)
  .component('lineItemDisplayPrice', LineItemPriceComponent)
  .component('lineItemQuantity', LineItemQuantityComponent)
  .component('salesPersonSelect', SalesPersonSelectComponent)
  .component('salesPersonInfo', SalesPersonInfoComponent)
  .component('wrReceiptPreviewLineItems', SaleSummaryLineItemsComponent)
  .component('reactPromotionBanner', ReactSalePromotionBannerComponent)
  .component('reactErrorBanner', ReactSaleErrorBannerComponent)
  .component('reactFulfilmentBanner', ReactSaleFulfilmentBannerComponent)
  .component('reactReturnBanner', ReactSaleReturnBannerComponent)
  .component('reactSaleComponent', ReactSaleViewComponent)
  .component('reactSaleActions', ReactSaleActionsComponent)
  .component('reactServiceBanner', ReactSaleServiceBannerComponent)
  .component('reactSummaryPanel', ReactSummaryPanel)
  .component('reactPaymentPanel', ReactPaymentPanel)
  .component('reactConfirmationPanel', ReactConfirmationPanel)
  .component('addProductToSaleModals', AddProductToSaleModalsComponent)
  .component('reactWorkspaceComponent', WorkSpaceComponent)
  .component(
    'receiptSelectionEmailToggle',
    ReceiptSelectionEmailToggleComponent
  )
  .component('receiptPrintSelected', ReceiptPrintSelectedComponent)
  .component('quotePrint', QuotePrintComponent)
  .component('unknownLineItem', UnknownLineItemComponent)
  .component('markAsUnfulfilledModal', MarkAsUnfulfilledModalComponent)
  .component('quoteCustomerModal', QuoteCustomerModalComponent)
  .component('serviceModal', ServiceModalComponent)
  .component('serviceSaleRefundModal', ServiceSaleRefundModalComponent)
  .component('accountBalanceSetupModal', AccountBalanceSetupModalComponent)
  .component('vbPromotionModal', vbPromotionModal)
  .component('wrToastNotifications', wrToastNotifications)
  .component('selectRegisterModal', SelectRegisterModalComponent)
  .component('noPermissionsPage', NoPermissionsPageComponent)
  .component('statusView', StatusViewComponent)
  .component('offlinePage', OfflinePage)

angular
  .module('webregister.controllers')
  .controller(
    'RegisterActionsPopoverController',
    RegisterActionsPopoverController
  )
  .controller('SetCashFloatController', SetCashFloatController)
  .controller('ErroredSalesModalController', ErroredSalesModalController)
  .controller(
    'OpenRegisterContinueSaleController',
    OpenRegisterContinueSaleController
  )
  .controller('RetrieveSalePopoverController', RetrieveSalePopoverController)
  .controller('SalePromoCodePopoverController', SalePromoCodePopoverController)
  .controller('OutletsDifferModalController', OutletsDifferModalController)
  .controller(
    'ReceiptSelectionPopoverController',
    ReceiptSelectionPopoverController
  )
  .controller('quoteCustomerModalController', QuoteCustomerModalController)
  .controller('serviceModalController', ServiceModalController)
  .controller(
    'serviceSaleRefundModalController',
    ServiceSaleRefundModalController
  )
  .controller('markUnfulfilledModalController', MarkUnfulfilledModalController)
  .controller(
    'accountBalanceSetupModalController',
    AccountBalanceSetupModalController
  )
  .controller('promotionModalController', PromotionModalController)
  .controller(
    'receiptSelectionEmailToggleController',
    ReceiptSelectionEmailToggleController
  )

angular
  .module('webregister.directives')
  .directive('attachCustomerTooltip', AttachCustomerTooltip)
